/**
 * Frontend application configuration
 */

// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// Application settings
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || 'International Construction Management';
export const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT || 'development';

// Authentication settings
export const APP_STORAGE_PREFIX = 'bfs'; // Change this later to migrate

export const TOKEN_STORAGE_KEY = `${APP_STORAGE_PREFIX}_access_token`;
export const REFRESH_TOKEN_STORAGE_KEY = `${APP_STORAGE_PREFIX}_refresh_token`;
export const USER_STORAGE_KEY = `${APP_STORAGE_PREFIX}_user`;

// The host's branding, cached so a tenant's own colours, logo and DEFAULT LANGUAGE are on screen at
// first paint instead of after a round trip. Named here rather than left as a bare string inside
// contexts/TenantContext.jsx because the sign-out path has to know which keys describe this DEVICE
// (and must survive) and which describe the person who just left — see shared/auth/signOut.js.
export const TENANT_BRANDING_STORAGE_KEY = 'tenant_branding';

// Feature flags
export const FEATURES = {
  enableNotifications: true,
  enableDarkMode: true,
  enableAuditLogs: import.meta.env.VITE_APP_ENVIRONMENT !== 'development',
};

// API endpoints - centralized for easier maintenance
export const ENDPOINTS = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    register: '/auth/register',
    resetPassword: '/auth/reset-password',
    requestPasswordReset: '/auth/request-reset',
  },
  user: {
    me: '/user/me',
    update: '/user/update',
    changePassword: '/user/change-password',
  },
};
